const TRIP_ITEMS_PATH = '/bff/business-trip/items';

export const buildBusinessTripItemListPath = (cityScope?: string[]): string => {
  const cities = cityScope?.map((city) => city.trim()).filter(Boolean) ?? [];
  if (!cities.length) {
    return TRIP_ITEMS_PATH;
  }

  const query = cities
    .map((city) => `cityScope=${encodeURIComponent(city)}`)
    .join('&');
  return `${TRIP_ITEMS_PATH}?${query}`;
};
